import sum from 'lodash/sum';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { devServer, devServer_somee } from '../globalSettings';
import { SERVER_API } from '../../config-global';


const initialState = {
    isLoading: false,
    error: null,
    formTypes: [],
    eventStatus: [],
    questionaire: [],
    InsertIntoQuestionnaire_User_ResponceSuccess:[]
  };

  const slice = createSlice({
    name: 'questionnaire',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
  
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },

      getUser_SelectAllQuestionFromQuestionnaireSuccess(state, action) {
        state.isLoading = false;
        state.questionaire = action.payload;
      },
      InsertIntoQuestionnaire_User_ResponceSuccess(state, action) {
        state.isLoading = false;
        state.InsertIntoQuestionnaire_User_ResponceSuccess = action.payload;
      },  
      User_UpdateIntoQuestionnaire_User_ResponceSuccess(state, action) {
        state.isLoading = false;
        state.User_UpdateIntoQuestionnaire_User_ResponceSuccess = action.payload;
      },  

      // clear insert data
      clearInsertData(state, action) {
        state.InsertIntoQuestionnaire_User_ResponceSuccess = null;
      }
    },
  });
  
  // Reducer
  export default slice.reducer;
  
  // Actions
  export const { clearInsertData } = slice.actions;

  export function User_SelectAllQuestionFromQuestionnaire() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await fetch(`${SERVER_API}User_SelectAllQuestionFromQuestionnaire`);
        const json = await response.json();
        const data = JSON.parse(json)[0];
        if (data && data.ReturnVal === 1) {
          dispatch(slice.actions.getUser_SelectAllQuestionFromQuestionnaireSuccess(JSON.parse(data.ReturnData)));
        } else {
          dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
        }
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }

  export function User_InsertIntoQuestionnaire_User_Responce(userID,pillarID,eventID,questionnaireID,questionnaireResponce,nameAndDesignation,organisationName,eventExpenditure,durationOfStay,eventActivitiesYes,eventActivitiesNo,activityDetails,eventObjective,attachments) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
  
      try {
        const requestUrl = `${SERVER_API}User_InsertIntoQuestionnaire_User_Responce?userID=${userID}&questionnaireID=${questionnaireID}&pillarID=${pillarID}&eventID=${eventID}&questionnaireResponce=${encodeURIComponent(questionnaireResponce)}
        &nameAndDesignation=${encodeURIComponent(nameAndDesignation)}&organisationName=${encodeURIComponent(organisationName)}&eventExpenditure=${encodeURIComponent(eventExpenditure)}&durationOfStay=${encodeURIComponent(durationOfStay)}&eventActivitiesYes=${encodeURIComponent(eventActivitiesYes)}&eventActivitiesNo=${encodeURIComponent(eventActivitiesNo)}&activityDetails=${encodeURIComponent(activityDetails)}&eventObjective=${encodeURIComponent(eventObjective)}&attachments=${encodeURIComponent(attachments)}
        `;
        const response = await fetch(requestUrl);
        const json = await response.json();
        const data = JSON.parse(json)[0];
        const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0];
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.InsertIntoQuestionnaire_User_ResponceSuccess(InsertedIDAfterJSON));
        } else {
          dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
        }
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }

  export function User_UpdateIntoQuestionnaire_User_Responce(userID,pillarID,eventID,questionnaireID, questionnaireResponce,questionnaireResponceID,nameAndDesignation,organisationName,eventExpenditure,durationOfStay,eventActivitiesYes,eventActivitiesNo,activityDetails,eventObjective,attachments) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
  
      try {
        const requestUrl = `${SERVER_API}User_UpdateIntoQuestionnaire_User_Responce?questionnaireResponceID=${questionnaireResponceID}&userID=${userID}&questionnaireID=${questionnaireID}&pillarID=${pillarID}&eventID=${eventID}&questionnaireResponce=${encodeURIComponent(questionnaireResponce)}&nameAndDesignation=${encodeURIComponent(nameAndDesignation)}&organisationName=${encodeURIComponent(organisationName)}&eventExpenditure=${encodeURIComponent(eventExpenditure)}&durationOfStay=${encodeURIComponent(durationOfStay)}&eventActivitiesYes=${encodeURIComponent(eventActivitiesYes)}&eventActivitiesNo=${encodeURIComponent(eventActivitiesNo)}&activityDetails=${encodeURIComponent(activityDetails)}&eventObjective=${encodeURIComponent(eventObjective)}&attachments=${encodeURIComponent(attachments)}
        `;
        const response = await fetch(requestUrl);
        const json = await response.json();
        const data = JSON.parse(json)[0];
        const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0].questionnaireResponceID;
        if (data.ReturnVal === 1) {
          dispatch(slice.actions.User_UpdateIntoQuestionnaire_User_ResponceSuccess(InsertedIDAfterJSON));
        } else {
          dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
        }
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }
